export const ASSETS = {
  modules:
  {
    name: 'Modules',
    data: [
      {
        name: 'Co2',
        title: 'Gas Mixer',
        description: 'Dissolve a mixture of different gases (CO2, O2, air) into your medium. Control the ratio of gases to achieve a defined medium pH or recreate specific cellular environments such as hypoxia.',
      },
      // { name: 'Cooling', title: 'Cooling', description: 'description 2' },
      {
        name: 'MechanicalStimulation',
        title: 'Mechanical Stimulation',
        description: 'Control and measure mechanical stimulation and its applied forces to your cells (as well as the forces produced by the cells) via different means. Whether you are stretching or compressing, rolling or mixing, OSPIN mechanical stimulation modules run the gamut from linear motors to pressurizing compartments.',
      },
      {
        name: 'Electrophysiology',
        title: 'Electrical Stimulation',
        description: 'Control electrical stimulation of your cells with the desired amplitude, frequency, and pulse length.',
      },
      {
        name: 'GlcLac',
        title: 'Glucose + Lactate Sensor',
        description: 'Measure the glucose and/or lactate concentration(s) of your medium. Use in combination with an upstream glucose and/or lactate reservoir to control the target values.',
      },
      // { name: 'Heating', title: 'Heating', description: 'Measure and control the temperature of your medium and/or cells with a target value.' },
      {
        name: 'Ph',
        title: 'Ph',
        description: 'Measure the pH of your medium. Use in combination with an upstream gas mixer to control the pH with a target value.',
      },
      {
        name: 'Po2',
        title: 'Dissolved Oxygen Sensor',
        description: 'Measure the DO of your medium. Use in combination with an upstream gas mixer to control the DO with a target value.',
      },
      {
        name: 'Pressure',
        title: 'Heartbeat Pump',
        description: 'Pump with dynamic pressure via a specific flow profile, e.g.: reproduce the pulse and flow of a beating heart.',
      },
      {
        name: 'Pump',
        title: 'Peristaltic Pump',
        description: 'Perfuse your cells with medium and move liquid through the system. In order to achieve automatic medium exchange, use a pump that adds fresh medium, a pump that removes used medium, and a pump that circulates medium.',
      },
      {
        name: 'TemperatureControl',
        title: 'Temperature Control',
        description: 'Measure and control the temperature of your medium and/or cells with a target value.',
      },
    ],
  },
  tubing: {
    name: 'Tubing',
    data: [
      {
        name: 'Tube180Deg',
        title: 'Tube180Deg',
        description: 'A straight tube that moves substances around the device',
      },
      {
        name: 'TubeCross',
        title: 'TubeCross',
        description: 'Tubes that intersect.',
      },
      {
        name: 'Tube90Deg',
        title: 'Tube90Deg',
        description: 'Tube corner for changing direction.',
      },
      {
        name: 'TubeSplit',
        title: 'TubeSplit',
        description: 'Tube with a split in 2 directions.',
      },
      {
        name: 'TubeValveCorner',
        title: 'TubeValveCorner',
        description: 'Tube with a valve to control when to change the direction.',
      },
      {
        name: 'TubeOverlay',
        title: 'TubeOverlay',
        description: 'Tubes that overlap but do not mix substances.',
      },
      {
        name: 'TubeValve',
        title: 'TubeValve',
        description: 'Tube valve to control flow.',
      },
    ],
  },
  accessories: {
    name: 'Accessories',
    data: [
      {
        name: 'CellChamber',
        title: 'Cell Chamber',
        description: `Provide a store for your cells. Cell chambers come in a wide variety of shapes, dimension, and functionalities that are tailored to their specific use cases, i.e. mechanical stimulation, electrical stimulation, temperature controlled storage, etc.
      As cell chambers can be very specific to a bioprocess, OSPIN offers full-service third-party chamber integration, in addition to consulting clients in the ideation and fabrication of novel cell chambers.`,
      },
      {
        name: 'Syringe',
        title: 'Syringe',
        description: 'Retrieve samples from your system',
      },
      {
        name: 'Pipe',
        title: 'Filter',
        description: 'Filter the medium in your system. If your system needs an open end (e.g. to take out a sample), consider using a filter and a valve to keep your system sterile.',
      },
      {
        name: 'Medium',
        title: 'Medium Reservoir',
        description: 'Store fresh medium for your cells that can be refilled at any time. Pump it into the system to make your cells happy.',
      },
      {
        name: 'Waste',
        title: 'Waste Reservoir',
        description: 'Remove medium or liquid from the system.',
      },
      {
        name: 'Glc',
        title: 'Glc',
        description: 'Store fresh glucose for your cells. If your cells are hungry, glucose can be a cost effective alternative to fresh medium. Use in combination with a downstream pump and a glucose sensor to achieve specific concentrations. ',
      },
      {
        name: 'PipeSwitch',
        title: 'On/Off Valve',
        description: 'Control where the medium can flow using a motor operated and programmable valve.',
      },
      {
        name: 'PipeSwitchCorner',
        title: 'Three-way Valve',
        description: 'Control where the medium can flow using a motor operated and programmable valve.',
      },
    ],
  },
}

export const API_LINK = 'https://api-dev.ospin-services.com/configurator/device-configurations'
